import React from 'react';
import { ExclamationStroke } from '@bloomberg/media-ui-icons';

import { CloseReason, Toast } from '../Toast';
import type { GlobalProps } from '../types';
import { classes } from '../utils';

import styles from './styles.module.css';

export type ToastErrorProps = GlobalProps & {
  open: boolean;
  text?: string;
  autoHideDuration?: number;
  inline?: boolean;
  onClose?: (reason: CloseReason) => void;
};

const DEFAULT_TEXT = 'We apologize but something went wrong. Please try again.';
const TOAST_POSITION = {
  horizontal: 'center',
  vertical: 'bottom',
} as const;

export const ToastError = React.forwardRef<HTMLDivElement, ToastErrorProps>(
  function ToastErrorComponent(props: ToastErrorProps, ref) {
    const {
      className,
      name = 'toast-error',
      open,
      text = DEFAULT_TEXT,
      autoHideDuration,
      unstyled,
      inline = false,
      onClose,
    } = props;

    const cx = classes([className, styles.toastError], {
      ...props,
      unstyled,
      name,
    });

    return (
      <Toast
        autoHideDuration={autoHideDuration}
        Icon={<ExclamationStroke className={styles.toastErrorIcon} />}
        className={cx}
        onClose={onClose}
        maxSize="full"
        name={name}
        open={open}
        position={TOAST_POSITION}
        ref={ref}
        variant="message"
        inline={inline}
      >
        {text}
      </Toast>
    );
  }
);
